<template>
  <div class="content extended-forms">
    <div class="row">
      <ArtistSelect
        class="col-md-3"
        @memberChangeEvent="getArtistInfo"
        :is-filter="true"
        :show-all-units="true"
        :include-unit-artist="true"
        :show-members="false"
        :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
      />
      <div class="col-md-3">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <el-select @change="getFanLogs" class="select-primary" size="large" placeholder="선택" v-model="state.state">
              <el-option v-for="option in state.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
            </el-select>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <el-select @change="getFanLogs" class="select-primary" size="large" placeholder="선택" v-model="accessLevel">
              <el-option v-for="option in FanLogAccessLevelOptions()" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
            </el-select>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <el-select @change="getFanLogs" class="select-primary" size="large" placeholder="선택" v-model="isRecent">
              <el-option v-for="option in recentOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <h4 class="card-title text-left">기간</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <el-date-picker type="daterange" start-placeholder="검색 시작일" end-placeholder="검색 종료일" v-model="searchPeriod" />
          </div>
        </div>
      </div>

      <div class="col-md-2">
        <h4 class="card-title text-left">검색어</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-input placeholder="검색어" v-model="searchWord">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-button @click="getFanLogs('detail')" type="default">검색</base-button>
          </div>
        </div>
      </div>
      <div class="col-md-2 text-left">
        <h4 class="card-title text-left">표시개수</h4>
        <el-select @change="getFanLogs" class="select-primary" size="large" placeholder="선택" v-model="limit">
          <el-option v-for="option in pageCounts" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
        </el-select>
      </div>
    </div>
    <div class="col-md-12">
      <h4 class="card-title text-left" />
      <div class="row">
        <div class="col-md-4 text-left">
          <base-button @click="hideContents()" type="danger">선택숨김</base-button>
        </div>
        <div class="col-md-4">
          <base-radio name="basic" inline v-model="viewType">기본</base-radio>
          <base-radio name="list" inline v-model="viewType">리스트</base-radio>
        </div>
      </div>
    </div>
    <div class="row" v-if="viewType === 'basic'">
      <div class="col-sm-3" v-for="(item, index) in list">
        <CardLayout
          :key="index"
          :index="index"
          :contentId="item.id"
          :scheduleId="item.scheduleId"
          :scheduleUrl="item.scheduleUrl"
          :fileIds="item.fileIds"
          :title="item.contents"
          :state="item.state"
          :regDate="item.displayTime"
          :btnDelete="true"
          :btnDetail="true"
          :has-check="true"
          @setCheckBox="setCheckBox"
          @contentDetail="goFanLogDetail"
          @deleteContent="deleteFanLog"
        />
      </div>
    </div>
    <div class="row" v-if="viewType === 'list'">
      <div class="col-md-12">
        <el-table :data="list">
          <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
          <el-table-column :min-width="135" align="right" label="공유페이지">
            <div slot-scope="props">
              <base-button @click.native="goShareUrl(props.row.idHash)" class="edit btn-link" type="warning" size="sm" icon>
                <i class="tim-icons icon-pencil" />
              </base-button>
            </div>
          </el-table-column>
          <el-table-column :min-width="135" align="right" label="상세">
            <div slot-scope="props">
              <base-button @click.native="handleEdit(props.row.id)" class="edit btn-link" type="warning" size="sm" icon>
                <i class="tim-icons icon-pencil" />
              </base-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
    </div>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import CardLayout from "@/pages/Components/CardLayout.vue";
import { BaseButton, BaseInput, BasePagination } from "@/components/index";
import swal from "sweetalert2";
import { URLUtils } from "@/util/URLUtils";
import moment from "moment";
import { formatDateTime } from "@/util/DateUtils";
import { FanLogAccessLevelOptions } from "./FanLogState";
import Endpoints from "@/common/Endpoints";

export default {
  components: {
    ArtistSelect,
    CardLayout,
    BaseInput,
    BaseButton,
    BasePagination,
  },
  async created() {
    if (!_.isEmpty(this.$route.query)) {
      if (this.$route.query.state) {
        this.state.state = parseInt(this.$route.query.state);
      } else {
        this.state.state = null;
      }
      if (this.$route.query.isRecent) {
        this.isRecent = parseInt(this.$route.query.isRecent);
      }
      if (this.$route.query.accessLevel) {
        this.accessLevel = parseInt(this.$route.query.accessLevel);
      }
      if (this.$route.query.searchWord) {
        this.searchWord = this.$route.query.searchWord;
      }
      if (this.$route.query.startDate && this.$route.query.endDate) {
        this.searchPeriod = [moment(this.$route.query.startDate, "YYYY-MM-DD").toDate(), moment(this.$route.query.endDate, "YYYY-MM-DD").toDate()];
      }
    }
  },
  data() {
    return {
      searchWord: null,
      viewType: "basic",
      accessLevel: null,
      limit: 20,
      pageCounts: [
        { label: 20, value: 20 },
        { label: 50, value: 50 },
        { label: 100, value: 100 },
      ],
      state: {
        state: 1,
        options: [
          { label: "전체", value: null },
          { label: "표시", value: 1 },
          { label: "숨김", value: 0 },
          { label: "삭제", value: -1 },
        ],
      },
      searchPeriod: [],
      list: [],
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50,
        },
        {
          prop: "contents",
          label: "내용",
          minWidth: 150,
        },
        {
          prop: "displayTime",
          label: "표시일",
          minWidth: 150,
        },
        {
          prop: "nickname",
          label: "작성자",
          minWidth: 120,
        },
      ],
      currentPage: 1,
      totalPages: 1,
      unitId: null,
      recentOptions: [
        { label: "전체", value: null },
        { label: "최근", value: 1 },
      ],
      isRecent: null,
    };
  },
  watch: {
    currentPage: {
      handler() {
        this.getFanLogs(this.$route.query.withParams, this.currentPage);
      },
    },
  },
  methods: {
    FanLogAccessLevelOptions() {
      return [{ label: "전체", value: null }, ...FanLogAccessLevelOptions];
    },
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      this.memberId = param.memberId;
      await this.getFanLogs();
    },
    async getFanLogs(withParams, page) {
      const queryParams = {
        unitId: this.unitId,
        state: this.state.state ?? undefined,
        isRecent: this.isRecent,
        accessLevel: this.accessLevel,
      };
      const params = { unitId: this.unitId, state: this.state.state, isRecent: this.isRecent, accessLevel: this.accessLevel, limit: this.limit };
      params.currentPage = page ? page : 1;
      if (withParams === "detail" || this.$route.query.withParams === "detail") {
        this.showSearchForm = true;
        if (!this.searchPeriod) {
          window.Toast.error("검색기간을 입력해 주세요");
          return;
        }
        if (this.searchPeriod) {
          queryParams.startDate = this.searchPeriod?.[0] ? moment(this.searchPeriod[0]).hour(0).minute(0).second(0).toISOString(true) : undefined;
          queryParams.endDate = this.searchPeriod?.[1] ? moment(this.searchPeriod[1]).hour(23).minute(59).second(59).toISOString(true) : undefined;
          params.startDate = this.searchPeriod?.[0] ? moment(this.searchPeriod[0]).hour(0).minute(0).second(0).toISOString() : undefined;
          params.endDate = this.searchPeriod?.[1] ? moment(this.searchPeriod[1]).hour(23).minute(59).second(59).toISOString() : undefined;
        }

        queryParams.searchWord = this.searchWord;
        queryParams.withParams = "detail";
        params.searchWord = this.searchWord;
        params.startTime = this.searchPeriod[0];
        params.endTime = this.searchPeriod[1];
      }
      if (this.unitId !== null) {
        const path = `/fanLog/fanLogs?${URLUtils.objectToQueryString(queryParams)}`;
        if (this.$route.fullPath !== path) {
          try {
            await this.$router.push(path);
          } catch (ex) {}
        }
      }
      const url = this.isRecent === 1 ? `/fanLogs/recent` : `/fanLogs`;
      return this.$axios
        .get(url, {
          params,
        })
        .then((res) => {
          this.list = res.data.data.data.map((d) => {
            d.displayTime = formatDateTime(d.displayTime);
            return d;
          });
          this.totalPages = Number(res.data.data.page);
          for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].scheduleId) {
              this.list[i].scheduleUrl = `/schedules/scheduleForm?scheduleId=${this.list[i].scheduleId}&unitId=${this.list[i].unitId}`;
            }
            if (this.list[i].imageIds) {
              this.list[i].fileIds = this.list[i].imageIds.split(",");
            }
            this.list[i].isChecked = false;
          }
        });
    },

    async deleteFanLog(param) {
      const contentId = param.contentId;
      swal
        .fire({
          title: "숨김 확인",
          text: `${contentId}번 팬로그를 숨김하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "숨김",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios
                .put(`/fanLogs/${contentId}/state`, {
                  params: { unitId: this.unitId, state: -1 },
                })
                .then((res) => {
                  window.Toast.success("팬로그가 숨김 되었습니다");
                  this.getFanLogs();
                });
            } catch (err) {
              window.Toast.error("팬로그 숨김 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    async hideContents() {
      swal
        .fire({
          title: "숨김 확인",
          text: `선택된 컨텐츠를 숨김하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "숨김",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            const fanLogIds = this.list
              .filter((item) => item.isChecked)
              .map((item) => {
                return item.id;
              });
            if (fanLogIds.length === 0) {
              window.Toast.error("선택된 팬로그가 없습니다");
              return;
            }
            for (const id of fanLogIds) {
              await this.$axios.put(`/fanLogs/${id}/state`, { params: { state: 0 } });
            }
            this.list.forEach((item, index) => {
              // item.isChecked = false;
              if (fanLogIds.includes(item.id)) {
                this.list.splice(index, 1);
              }
            });
            window.Toast.success("팬로그가 숨김 되었습니다");
          }
        });
    },

    goFanLogDetail(param) {
      window.open(`/fanLog/fanLogDetail?fanLogId=${param.contentId}`);
    },

    handleEdit(fanLogId) {
      window.open(`/fanLog/fanLogDetail?fanLogId=${fanLogId}`);
    },

    setCheckBox(param) {
      this.list[param.index].isChecked = param.isChecked;
    },

    goShareUrl(idHash) {
      window.open(`${Endpoints.sharePageUrl}/f/${idHash}`);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  .row {
    margin-bottom: 20px;
  }
}
</style>
